export default __webpack_public_path__ + "static/sechtml-a5af06e899db9dca1610c9e582116504.avif";